"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeStamp = void 0;
class TimeStamp {
    constructor(userData, offset) {
        const { ID, firstName, lastName, emailAddress } = userData;
        // For safety, in case a js file decides to send through too much
        this.user = { ID, firstName, lastName, emailAddress };
        this.time = Date.now() + Number(offset ?? 0);
    }
}
exports.TimeStamp = TimeStamp;
//# sourceMappingURL=Metadata.js.map